import { useState, useEffect } from 'react';
import { Tabs, Space, Form, Spin, Button } from 'antd';
import Table from '../../../../TableResizable';
import type { TabsProps } from 'antd';
import { UserOutlined, ContactsOutlined, UsergroupAddOutlined } from '@ant-design/icons';
import { ViewAgenda } from '@mui/icons-material';
import axios from 'axios';
import Tab1 from './Tab1';
import Tab2 from './Tab2';
import Tab3 from './Tab3';
import Utilisateur from '../../../../../Models/Utilisateur';
import { useAuthHeader, useAuthUser } from '../../../../../Services/Auth/sessionAuth';
import Data from '../../../../../Data/Data.json';
import SweetAlert from 'sweetalert2';
import { Crypter } from '../../../../../Functions/Security/Crypter';
import { Typography } from '@mui/material';
import formatNumber from '../../../../../Functions/Traitement/FormatNumber';
import { DemandeIjarahDto } from '../../../../../Models/DemandeIjarahDto';
import DataTypeTable from '../../../../../Types/DataTypeTable';
import { useNavigate } from 'react-router-dom';
import ReformatDate from '../../../../../Functions/Traitement/ReformatDate';
import ParamsPicklist from '../../../../../Types/ParamsPicklist';
import formatDate from '../../../../../Functions/Traitement/fomatDate';
import Tab4 from './Tab4';
import Tab5 from './Tab5';
import { Box } from '@mui/material';

const PropositionIjarah = () => {
  const auth = useAuthUser();
  const user: Utilisateur = JSON.parse(JSON.stringify(auth()));
  const authHeader = useAuthHeader();

  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [StartForm, SetStartForm] = useState(true);
  const [, forceUpdate] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);
  const [ajoutActve, setAjoutActif] = useState(false);
  const [modifActve, setModifActve] = useState(true);
  const [enregActve, setEnregActve] = useState(true);
  const [supActive, setSupActive] = useState(true);
  const [impActive, setImpActive] = useState(true);
  const [actuActive, setActActive] = useState(true);
  const [annulActive, setAnnulActive] = useState(true);
  const [consulActive, setConsulActive] = useState(false);
  const [pageLoad, setPageLoad] = useState(true);
  const [sbmit, setSbmit] = useState('');
  const [data, setData] = useState<DemandeIjarahDto[]>([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [garantiesTableau, setGarantiesTableau] = useState<DataTypeTable[]>([]);
  const [datatabamort, setdatatabamort] = useState<any[]>([]);
  const [dataProv, setDataProv] = useState<any[]>([]);
  const navigate = useNavigate();

  useEffect(() => {
    forceUpdate({});
  }, []);

  const initialiazeButton = () => {
    setAjoutActif(false);
    setModifActve(true);
    setEnregActve(true);
    setSupActive(true);
    setImpActive(true);
    setActActive(true);
    setAnnulActive(true);
    setConsulActive(false);
  };

  const SetStart = () => {
    setSbmit('add');
    setAjoutActif(true);
    setEnregActve(false);
    setAnnulActive(false);
    setConsulActive(true);
    form.resetFields();
    setGarantiesTableau([]);
    setdatatabamort([]);
    setDataProv([]);
  };

  const SetEndStart = () => {
    SetStartForm(true);
  };

  const loadFinancement = () => {
    localStorage.clear();
    setPageLoad(false);
    setLoading(true);
    setData([]);

    let searchClientComptes: ParamsPicklist = {
      CodeAgence: user.codage,
      Table: 'DEMAND_FINIJARA',
      Colonne1: 'EtapeActuelle',
      Colonne2: '',
      Init: 'PROPOSITION',
      Colagence: 'CODAGE',
      Choix: 34,
    };

    var config = {
      method: 'get',
      maxBodyLength: Infinity,
      url: Data.ApiUrl.AnySearch,
      headers: {
        'Content-Type': 'application/json',
        Authorization: authHeader(),
        CypherSearch: Crypter.encrypt(JSON.stringify(searchClientComptes)),
      },
    };

    axios
      .request(config)
      .then((response) => {
        if (response.data) {
          const res = JSON.parse(Crypter.decrypt(response.data)).Value;
          if (res.StatutCode == 200) {
            let datas = res.Result.Table;
            if (datas.length === 0) {
              SweetAlert.fire({ title: 'Aucune demande Ijarah en cours', icon: 'warning' });
              setData([]);
            } else {
              const newData: DemandeIjarahDto[] = datas.map((data: any, indice: number) => ({
                ...data,
                key: indice,
                NumeroDemande: data.NumeroDemande,
                Numcli: data.NUMCLI,
                NOMCLI: data.NOMCLI,
                DateDemande: data.DateDemande ? new Date(data.DateDemande.substring(0, 10)).toLocaleDateString('fr') : '',
                MontantDemande: data.CoutAcquisitionDemande,
              }));
              setData(newData);
            }
          }
        }
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        console.log(error);
        SweetAlert.fire({ title: 'Error', text: error, icon: 'error' });
      });
  };

  if (pageLoad) {
    loadFinancement();
  }

  const columns = [
    {
      title: 'Date Demande',
      dataIndex: 'DateDemande',
    },
    {
      title: 'N° Demande',
      dataIndex: 'NumeroDemande',
    },
    {
      title: 'N° Client',
      dataIndex: 'Numcli',
    },
    {
      title: 'Nom Client',
      dataIndex: 'NOMCLI',
    },
    {
      title: 'Montant demandé',
      dataIndex: 'CoutAcquisitionDemande',
      render: (value: any) => formatNumber(value),
    },
  ];

  const onFinishFailed = async (errorInfo: any) => {
    var errors: any = [];
    errorInfo.errorFields.map((error: any) => {
      errors.push(error.name + '');
    });
    SweetAlert.fire({
      title: 'Veuillez remplir tous les champs obligatoires',
      text: errors.toString().replaceAll(',', ' - '),
      icon: 'warning',
      confirmButtonText: 'OK',
    });
  };

  const onFinish = (values: any) => {
    const proposition: DemandeIjarahDto = {
      CODAGE: user.codage,
      DatePremEch: formatDate(values.DatePremEch),
      Numcli: values.NUMCLI,
      NOMCLI: values.lib_NUMCLI,
      Documents: values.Document || [],
      ...values,
    } as any;

    SweetAlert.fire({
      title:
        'Voulez-vous enregistrer la proposition Ijara du client : ' +
        values.lib_NUMCLI +
        ' pour le demande ' +
        values.NumeroDemande +
        ' ? ',
      showCancelButton: true,
      color: 'green',
      confirmButtonText: 'Yes',
      confirmButtonColor: 'green',
      cancelButtonColor: 'darkred',
      cancelButtonText: 'No',
      showLoaderOnConfirm: true,
      icon: 'question',
    }).then((res) => {
      if (res.isConfirmed) {
        try {
          setLoading(true);
          setIsSubmit(true);
          proposition.UtilPropose = user.coduti;
          proposition.CodeUti = user.coduti;
        //   proposition.DatePropose = user.datjour;

          let data = Crypter.encrypt(JSON.stringify(proposition));
          let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: Data.ApiUrl.PropositionIjarah,
            headers: {
              Authorization: authHeader(),
              'Content-Type': 'application/json',
            },
            data: data,
          };

          axios
            .request(config)
            .then((response) => {
              setLoading(false);
              if (response.data) {
                const res = JSON.parse(Crypter.decrypt(response.data)).Value;
                if (res.StatutCode == 200) {
                  initialiazeButton();
                  form.resetFields();
                  setGarantiesTableau([]);
                  setdatatabamort([]);
                  setDataProv([]);
                  setImpActive(false);
                  loadFinancement();
                  SweetAlert.fire({ title: res.Message, text: res.Result, icon: 'success' });
                } else {
                  SweetAlert.fire({ title: res.Message, text: res.Result, icon: 'warning' });
                }
              }
            })
            .catch((error) => {
              setLoading(false);
              console.log(error);
              SweetAlert.fire({ title: error, icon: 'error' });
            });
        } catch (error) {
          SweetAlert.fire({ title: 'Error occurred while saving proposition', icon: 'error' });
        }
      }
    });
  };
 
  const consultTypeIjarah = () => {
    if (form.getFieldValue('CodeIjara') == null) {
      SweetAlert.fire({ title: 'Svp renseigner le Code du type de Ijara ', icon: 'warning' });
    } else {
      let data = Crypter.encrypt(form.getFieldValue('CodeIjara'));
      if (data.length != 0) {
        setLoading(true);
        let config = {
          method: 'get',
          maxBodyLength: Infinity,
          url: Data.ApiUrl.ReadParamsIjarah,
          headers: {
            CypherCodeIjara: data,
            Authorization: authHeader(),
            'Content-Type': 'application/json',
          },
        };
        axios
          .request(config)
          .then((response) => {
            setLoading(false);
            if (response.data) {
              const res = JSON.parse(Crypter.decrypt(response.data)).Value;
              console.log(res);
              if (res.StatutCode == 200) {
                const frais = res.Result.Table1[0]?.MontantFrais || 0;
                form.setFieldValue('CodeFrais', res.Result.Table4?.map((x: any) => x.CODOPE) || []);
                form.setFieldValue('FraisService', frais);
              } else {
                SweetAlert.fire({ title: res.Message, text: res.Result, icon: 'warning' });
              }
            }
          })
          .catch((error) => {
            setLoading(false);
            console.log(error);
            SweetAlert.fire({ title: 'Error', text: error, icon: 'error' });
          });
      }
    }
  };

  const onSelectChange = (newSelectedRowKeys: any) => {
    const requestedIndex = Array.isArray(newSelectedRowKeys) ? newSelectedRowKeys[0] : newSelectedRowKeys;
    if (requestedIndex !== undefined && data[requestedIndex]) {
      form.setFieldsValue(data[requestedIndex]);
      handleDemandeIjarah(data[requestedIndex].NumeroDemande);
    }
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  const items: TabsProps['items'] = [
    {
      key: '1',
      label: (
        <span id='Tab'>
          <UserOutlined /> Proposition
        </span>
      ),
      children: <Tab1 form={form} consultTypeIjarah={consultTypeIjarah} />,
    },
    
    {
      key: '2',
      label: (
        <span id='Tab'>
          <UserOutlined /> Documents
        </span>
      ),
      children: <Tab5 form={form} />,
    },

    {
      key: '3',
      label: (
        <span id='Tab'>
          <ContactsOutlined /> Garanties
        </span>
      ),
      children: <Tab2 form={form} garantiesTableau={garantiesTableau} />,
    },
    {
      key: '4',
      label: (
        <span id='Tab'>
          <UsergroupAddOutlined /> Frais de Gestion
        </span>
      ),
      children: <Tab3 form={form} />,
    },
    {
      key: '5',
      label: (
        <span id='Tab'>
          <ViewAgenda /> Tableaux
        </span>
      ),
      children: <Tab4 form={form} data={datatabamort} dataProv={dataProv} />,
    },
  ];

  function handleDemandeIjarah(numeroDemande?: string) {
    const demande = numeroDemande ?? form.getFieldValue('NumeroDemande');
    console.log(demande);
    // alert(demande)
    localStorage.setItem(Data.LocalVariable.reset, '1');
    let dataCrypt = Crypter.encrypt(demande);
    let dataction = Crypter.encrypt('READ_DEMANDE');
    console.log("datacrypt",dataCrypt,"dataction",dataction);

    if (dataCrypt.length != 0) {
      initialiazeButton();
      setLoading(true);
      form.resetFields();
      form.setFieldValue('NumeroDemande', demande);
      let config = {
        method: 'get',
        maxBodyLength: Infinity,
        url: Data.ApiUrl.ReadFinancementIjarah,
        headers: {
          CypherNumeroDemandeIjara: dataCrypt,
          CypherAction: dataction,
          Authorization: authHeader(),
          'Content-Type': 'application/json',
        },
      };
      axios
        .request(config)
        .then((response) => {
          setLoading(false);
          if (response.data) {
            const res = JSON.parse(Crypter.decrypt(response.data)).Value;
            console.log(res);
            if (res.StatutCode == 200) {
              form.setFieldsValue(res.Result.Table1[0]);
              form.setFieldValue('DatePremEch', ReformatDate(res.Result.Table1[0].DatePremEch));
              form.setFieldValue('lib_NUMCLI', res.Result.Table1[0].NOMCLI);
              form.setFieldValue('MontantDemande', res.Result.Table1[0].CoutAcquisitionDemande);

              form.setFieldValue('CoutAchatPropose', res.Result.Table1[0].CoutAcquisitionDemande);
              form.setFieldValue('MargeLocativeProp', res.Result.Table1[0].MargeLocativeDem );

              const garantiesRetournees: DataTypeTable[] = [];
              if (res.Result.Table2) {
                res.Result.Table2.map((item: any) => {
                  garantiesRetournees.push({ ...item, valCouvert: item.MontantCouvert });
                });
                form.setFieldValue('montantGarantieCouvert', garantiesRetournees.reduce((sum, g) => sum + (g.valCouvert || 0), 0));
              }

              const newData: any[] = [];
              if (res.Result.Table3) {
                res.Result.Table3.map((item: any) => {
                  newData.push({
                    ...item,
                    CapitalRembourse: formatNumber(item.CapitalRembourse),
                    CapitalRestant: formatNumber(item.CapitalRestant),
                    DateEcheance: item.DateEcheance ? new Date(item.DateEcheance.substring(0, 10)).toLocaleDateString('fr') : '',
                  });
                });
              }

              setGarantiesTableau(garantiesRetournees);
              setdatatabamort(newData);
              if (res.Result.Table5) {
                 setDataProv(res.Result.Table5 as any);
              } else {
                 setDataProv([]);
              }
              consultTypeIjarah();
              initialiazeButton();
              cunsultButton();
              setEnregActve(false);
            } else {
              localStorage.removeItem(Data.LocalVariable.reset);
              SweetAlert.fire({ title: res.Message, icon: 'warning' });
              setSelectedRowKeys([]);
            }
          }
        })
        .catch((error) => {
          localStorage.removeItem(Data.LocalVariable.reset);
          setLoading(false);
          console.log(error);
          SweetAlert.fire({ title: error, icon: 'error' });
          setSelectedRowKeys([]);
        });
    }
  }

  function cunsultButton() {
    setAnnulActive(false);
    setModifActve(false);
  }

  function modifButton() {
    setSbmit('update');
    setModifActve(true);
    setAjoutActif(true);
    setEnregActve(false);
    setConsulActive(true);
  }

  return (
    <div className="tab">
      <Typography align="center" className="formTitle"><b>PROPOSITION Ijarah</b></Typography>
      <Spin spinning={loading} size="large" style={{ color: 'green' }}>
        <Form
          disabled={!ajoutActve}
          preserve
          autoComplete="off"
          labelAlign="left"
          form={form}
          name="dynamic_form_complex"
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          style={{ minWidth: 'auto', maxWidth: 'auto' }}
        >
          <div className="bG">
            <legend><Typography color={'darkgreen'}>Actions</Typography></legend>
            <Form.Item shouldUpdate className="bouttong">
              <Space direction="vertical" style={{ width: '100%' }}>
                <Button size="large" className="bt_add" disabled={modifActve} onClick={modifButton} type="ghost" htmlType="button" block>
                  Modifier
                </Button>
                <Button size="large" className="bt_add" onSubmit={onFinish} disabled={enregActve} type="ghost" htmlType="submit" block>
                  Proposer
                </Button>
                <Button size="large" disabled={annulActive} onClick={() => { form.resetFields(); initialiazeButton(); setGarantiesTableau([]); setdatatabamort([]); }} className="bt_add" type="ghost" htmlType="button" block>
                  Annuler
                </Button>
              </Space>
            </Form.Item>
          </div>
          <div className="clientP">
           <div>
            {/* Onglets */}
            <Tabs size="small" type="card" defaultActiveKey="1" items={items} />
           </div>

           {/* Tableau des demandes – positionné en dessous */}
           <Box sx={{ width: '85%', mt: 0 }}>
           <Spin spinning={loading}>
           <Form disabled={false}>
             <Table
              size='small'
              style={{ width: '100%' }}
              rowSelection={{ ...rowSelection, type: 'radio' }}
              columns={columns}
              dataSource={data}
              scroll={{ y: 200, x: 10 }}
              pagination={false}
             />
           </Form>
          </Spin>
        </Box>
      </div>
        </Form>
      </Spin>
    </div>
  );
};

export default PropositionIjarah;


